var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{staticClass:"d-flex"},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1),_c('div',{staticClass:"flex-grow-1"}),(_vm.$route.name !== 'login')?_c('AppFooter'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }